var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-img',{attrs:{"aspect-ratio":10/9,"src":"img/logo-innsoftech.png","width":"500"}},[_c('v-row',{staticClass:"lightbox white--text pa-2 fill-height",attrs:{"align":"end"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }